import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "advertising-item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "advertising-item-type" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "advertising-item-op" }

import { useApi } from '@/hooks/useApi';
import { useBaseAsync } from 'juou-managebase-ui';
import { ref } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvertisingItem',
  props: {
    data: {},
    isH: { type: Boolean },
    isFirst: { type: Boolean },
    isLast: { type: Boolean }
  },
  emits: ['change'],
  setup(__props: any, { emit: __emit }) {

const loading = ref(false);


const props = __props;

const emits = __emit;


const move = useBaseAsync(async(type: 'up' | 'down') => {
  try {
    loading.value = true;
    await useApi().advertisingApi.moveAdvertisingadvertising({
      advertisingId: props.data.id,
      up: type === 'up',
    });
    emits('change');
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
});

const del = useBaseAsync(() => {
  ElMessageBox.confirm('删除后无法恢复，确定要删除吗？', '删除', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
  }).then(async() => {
    try {
      loading.value = true;
      await useApi().advertisingApi.delAdvertisingadvertising(props.data.id);
      emits('change');
    } catch (error) {
      console.log(error);
    } finally {
      loading.value = false;
    }
  });
});


return (_ctx: any,_cache: any) => {
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold")!
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold")!
  const _component_Delete = _resolveComponent("Delete")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: `${_unref(useApi)().baseUrl}${_ctx.data.image}`,
      style: {"height":"40px"},
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.data.type === 'weapp' ? '小程序' : (_ctx.data.type === 'wx' ? '公众号文章' : '插件')), 1),
    _createElementVNode("div", null, " URL/Path：" + _toDisplayString(_ctx.data.url), 1),
    (_ctx.data.type === 'weapp' || _ctx.data.type === 'plugin')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " appid: " + _toDisplayString(_ctx.data.appid), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.isH && !_ctx.isFirst)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "up",
            onClick: _cache[0] || (_cache[0] = () => _unref(move)('up'))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowUpBold)
              ]),
              _: 1
            }),
            _createTextVNode(" 前移 ")
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isH && !_ctx.isLast)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "down",
            onClick: _cache[1] || (_cache[1] = () => _unref(move)('down'))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowDownBold)
              ]),
              _: 1
            }),
            _createTextVNode(" 后移 ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.isH && !_ctx.isFirst)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "left",
            onClick: _cache[2] || (_cache[2] = () => _unref(move)('up'))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowLeftBold)
              ]),
              _: 1
            }),
            _createTextVNode(" 前移 ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.isH && !_ctx.isLast)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "right",
            onClick: _cache[3] || (_cache[3] = () => _unref(move)('down'))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowRightBold)
              ]),
              _: 1
            }),
            _createTextVNode(" 后移 ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "del",
        onClick: _cache[4] || (_cache[4] = () => _unref(del)())
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_Delete)
          ]),
          _: 1
        }),
        _createTextVNode(" 删除 ")
      ])
    ])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})